import { render, staticRenderFns } from "./fork_sync_conflicts_modal.vue?vue&type=template&id=3f479c01&vue3"
import script from "./fork_sync_conflicts_modal.vue?vue&type=script&lang=js&vue3"
export * from "./fork_sync_conflicts_modal.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports